import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e8c1a9e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cell quantity text-right" }
const _hoisted_2 = { class: "cell product" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "cell extras"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "cell remarks" }
const _hoisted_7 = { class: "cell total text-right" }
const _hoisted_8 = {
  key: 0,
  class: "discount"
}
const _hoisted_9 = { class: "extra-quantity text-right" }
const _hoisted_10 = { class: "extra" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["row", { deleted: _ctx.product.is_deleted }])
    }, [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.product.quantity) + "x", 1),
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.product.product?.category
                    ? _ctx.product.product?.category?.title?.default
                    : null) + " ", 1),
        (_ctx.product.product?.category)
          ? (_openBlock(), _createElementBlock("br", _hoisted_3))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.label), 1)
      ]),
      (!_ctx.showSeparateExtras)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.product.extras)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.parseProductExtras(_ctx.product.extras).join(", ")), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", null, _toDisplayString(_ctx.product.remarks), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createTextVNode(_toDisplayString(_ctx.useFormatCurrency(_ctx.product.total)) + " ", 1),
        (_ctx.product.discount)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, " -" + _toDisplayString(_ctx.useFormatCurrency(_ctx.product.discount)), 1))
          : _createCommentVNode("", true)
      ])
    ], 2),
    (_ctx.showSeparateExtras)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.product.extras, (extra) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "extra-item",
            key: extra.id
          }, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(extra.quantity) + "x", 1),
            _createElementVNode("div", _hoisted_10, _toDisplayString(extra.title), 1),
            _hoisted_11,
            _hoisted_12
          ]))
        }), 128))
      : _createCommentVNode("", true)
  ], 64))
}